import { colors } from '@ui/colors'

type PointType = 'eye' | 'frame'
type PointVariant = 'auto' | 'modified' | 'danger' | 'neutral'

type Coords = {
  x: number
  y: number
}

export interface PointProps {
  type: PointType
  variant: PointVariant
}

export interface PointsProps {
  points: (PointProps & Coords)[]
}

export const colorOuter: Record<PointType, Record<PointVariant, string>> = {
  eye: {
    auto: colors.white50,
    modified: colors.white50,
    danger: colors.deadred,
    neutral: colors.white50,
  },
  frame: {
    auto: colors.black25,
    modified: colors.black25,
    danger: colors.deadred,
    neutral: colors.black25,
  },
}

export const colorInner: Record<PointType, Record<PointVariant, string>> = {
  eye: {
    auto: colors.cyan,
    modified: colors.orangel,
    danger: colors.deadred,
    neutral: colors.white,
  },
  frame: {
    auto: colors.emerald,
    modified: colors.orangel,
    danger: colors.deadred,
    neutral: colors.white,
  },
}
